import styled from "styled-components";

const FeatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px;
  left: 16px;
  top: 859px;
  background: #f9f9f9;
  border-radius: 0px 24px;
`;

const Span = styled.span`
  background: #ffb81c;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  color: #5e514d;
`;

const Title = styled.h5`
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;
  color: #5e514d;
`;

const TitleItem = styled.p`  
  min-height: 50px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #5e514d;
`;

const Description = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #5e514d;
  text-align: justify;
`;

const CardFeature = (props) => {
  return (
    <FeatureContainer>
      <Title className="mb-4">{props.title}</Title>
      <div className="row">
        {props.items.map((item, i) => {
          return (
            <div className="mb-3 col-lg-4 col-12" key={i}>
              <Span className="d-flex align-items-center justify-content-center p-2 mb-2">
                {i + 1}
              </Span>
              <TitleItem className="mb-2">{item.title}</TitleItem>
              <Description
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>
          );
        })}
      </div>
    </FeatureContainer>
  );
};

export default CardFeature;
